import { useCallback } from 'react';

import { BoatsApi } from '../api';
import { useBoatForm } from './useBoatForm';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useCreateBoat = (
  userId: number,
  onSuccess: undefined | (() => void),
) => {
  const {
    error,
    loading,
    name,
    polarsFile,
    resetFiles,
    sailsFile,
    setError,
    setLoading,
    setName,
    setPolarFile,
    setSailsFile,
    setWaveFile,
    waveFile,
  } = useBoatForm(undefined);

  const updateBoatFiles = useCallback(async () => {
    try {
      setLoading(true);
      await BoatsApi.createBoat({
        userId,
        name,
        files: {
          sails: sailsFile,
          polars: polarsFile,
          wave: waveFile,
        },
      });
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, [sailsFile, userId, polarsFile, waveFile, onSuccess, name]);

  const valid = !!(polarsFile && name);

  return {
    error,
    loading,
    updateBoatFiles,
    polarsFile,
    setPolarFile,
    sailsFile,
    setSailsFile,
    waveFile,
    setWaveFile,
    valid,
    resetFiles,
    name,
    setName,
  };
};
